import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/utils/tailwind.util';
export const WithUnderline = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(({
  children,
  className,
  ...rest
}, ref) => {
  return <div {...rest} ref={ref} className={cn('relative py-xs [&:not(:focus-within)]:group-hover:shadow-[inset_0_-1px_0_0_theme(colors.opacity.black.3)]', 'focus-within:shadow-[inset_0_-2px_0_0_theme(colors.violet.300)]', className)}>
      {children}
    </div>;
});